import React from 'react';
import { Pencil, Trash2, Power, Loader2, Flame } from 'lucide-react';
import { Button } from '../ui/button';
import { adminUpdateJob } from '../../api';

const JobsTable = ({ jobs, loading, onEdit, onDelete, onChanged }) => {
  const toggleHot = async (j, e) => {
    e.stopPropagation();
    try { await adminUpdateJob(j.id, { is_hot: !j.is_hot }); onChanged && onChanged(); }
    catch (err) { console.warn('toggle hot failed', err?.message); }
  };
  if (loading) {
    return (
      <div className="p-10 text-center text-slate-400">
        <Loader2 className="w-5 h-5 animate-spin inline" /> Loading...
      </div>
    );
  }
  if (jobs.length === 0) {
    return <div className="p-10 text-center text-slate-400">No jobs yet. Click &ldquo;New Job&rdquo; to create one.</div>;
  }
  return (
    <table className="w-full text-sm">
      <thead className="bg-slate-900/60 text-slate-400 text-xs uppercase tracking-wider">
        <tr>
          <th className="text-left px-5 py-3">#</th>
          <th className="text-left px-5 py-3">Title</th>
          <th className="text-left px-5 py-3">Tag</th>
          <th className="text-left px-5 py-3">Type</th>
          <th className="text-left px-5 py-3">Clearance</th>
          <th className="text-left px-5 py-3">Status</th>
          <th className="text-right px-5 py-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        {jobs.map(j => (
          <tr key={j.id} className="border-t border-cyan-400/5 hover:bg-slate-900/40">
            <td className="px-5 py-4 font-mono text-cyan-300 text-xs">{j.job_number || '—'}</td>
            <td className="px-5 py-4 text-white font-medium">{j.title}{j.is_hot && <Flame className="w-3.5 h-3.5 text-orange-400 inline ml-2 -mt-0.5" />}</td>
            <td className="px-5 py-4 text-slate-300">{j.tag}</td>
            <td className="px-5 py-4 text-slate-300">{j.type}</td>
            <td className="px-5 py-4 text-slate-300">{j.clearance_level}</td>
            <td className="px-5 py-4">
              <span className={`text-xs px-2 py-1 rounded ${j.active ? 'bg-emerald-400/10 text-emerald-300 border border-emerald-400/20' : 'bg-slate-700/40 text-slate-400 border border-slate-600/30'}`}>
                <Power className="w-3 h-3 inline mr-1" />{j.active ? 'Active' : 'Hidden'}
              </span>
            </td>
            <td className="px-5 py-4 text-right">
              <Button onClick={(e) => toggleHot(j, e)} variant="outline" className={`h-8 mr-2 bg-transparent ${j.is_hot ? 'border-orange-500/50 text-orange-400 hover:bg-orange-950/30' : 'border-slate-700 text-slate-400 hover:bg-slate-800'}`} title={j.is_hot ? 'Unmark as hot' : 'Mark as hot'}><Flame className="w-3.5 h-3.5" /></Button>
              <Button onClick={() => onEdit(j)} variant="outline" className="h-8 mr-2 border-slate-700 bg-transparent hover:bg-slate-800 text-slate-200"><Pencil className="w-3.5 h-3.5" /></Button>
              <Button onClick={() => onDelete(j)} variant="outline" className="h-8 border-red-900/40 bg-transparent hover:bg-red-950/40 text-red-300"><Trash2 className="w-3.5 h-3.5" /></Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default JobsTable;
